module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__content"
  }, [_c('div', {
    staticClass: "widget__row"
  }, [_c('div', {
    staticClass: "widget__column project-details"
  }, [(_vm.content.entityType) ? _c('div', {
    ref: "type",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-type')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.entityType))])]) : _vm._e(), (_vm.content.year) ? _c('div', {
    ref: "year",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-year')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.year))])]) : _vm._e(), (_vm.content.client) ? _c('div', {
    ref: "client",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-client')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.client))])]) : _vm._e()]), _c('div', {
    staticClass: "widget__column widget__column--btn"
  }, [(_vm.content.link && _vm.content.link.url) ? _c('base-button', {
    ref: "button",
    staticClass: "project-url",
    attrs: {
      "url": _vm.content.link.url,
      "label": _vm.$t('launch-website'),
      "target": "_blank"
    }
  }) : _vm._e()], 1)]), (_vm.content.goal) ? _c('div', {
    staticClass: "widget__row"
  }, [_c('div', {
    ref: "goal",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-goals')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.goal))])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71b7c26e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/widgets/project-description.vue
// module id = 492
// module chunks = 0